/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */
import './ConfirmationModal.scss';

import { noop } from 'lodash';
import { element, func, oneOfType, string } from 'prop-types';
import React, { Component } from 'react';

export default class ConfirmationModal extends Component {
  static propTypes = {
    modalClassname: oneOfType([string, element]),
    title: oneOfType([string, element]),
    content: oneOfType([string, element]),
    children: func.isRequired,
    onCancel: func,
    onConfirm: func.isRequired
  };

  static defaultProps = {
    onCancel: noop,
    onConfirm: noop
  };

  state = {
    showModal: false
  };

  openModal = (cb) => this.setState({ showModal: true }, cb);

  closeModal = (cb) => this.setState({ showModal: false }, cb);

  render() {
    const {
      modalClassname = '',
      title,
      content,
      children,
      onCancel,
      onConfirm
    } = this.props;
    return (
      <span>
        {children({ openModal: () => this.openModal(noop) })}
        {this.state.showModal && (
          <div
            className={`confirmation-container ${modalClassname}`}
            onClick={() => this.closeModal(onCancel)}>
            <div className="confirmation-modal-popup">
              <div className="confirmation-title">{title}</div>
              <p className="confirmation-message">{content}</p>
              <div className="confirmation-options">
                <button
                  className="cancel"
                  onClick={() => this.closeModal(onCancel)}>
                  Cancel
                </button>
                <button
                  className="confirm"
                  onClick={() => this.closeModal(onConfirm)}>
                  Continue
                </button>
              </div>
            </div>
          </div>
        )}
      </span>
    );
  }
}
